import PropTypes from 'prop-types';

const Euro = ({ color, size, ...props }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} {...props}>
        <g clipPath="url(#a)">
            <path
                d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12m-18.016.967v1.04H7.47q.446 1.914 1.832 3.053 1.386 1.138 3.481 1.138 1.997 0 3.234-.94 1.238-.94 1.584-2.607h-1.534q-.264 1.056-1.073 1.69-.809.636-2.21.636-1.453 0-2.46-.784-1.005-.783-1.402-2.186h4.191v-1.04H8.74a8.393 8.393 0 0 1 0-1.501h4.372v-1.023H8.938q.38-1.42 1.386-2.195t2.458-.775q1.403 0 2.211.652.81.651 1.073 1.724H17.6q-.346-1.7-1.584-2.648-1.238-.95-3.234-.949-2.078 0-3.465 1.138-1.386 1.14-1.831 3.053H5.984v1.023h1.337a9 9 0 0 0 0 1.502z"
                fill={color}
                fillRule="evenodd"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path d="M0 0h24v24H0z" fill={color} />
            </clipPath>
        </defs>
    </svg>
);

export default Euro;

Euro.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
